// import ClickSound from '@/assets/audio/click2.mp3'
import store from '@/store'

// 音效播放类
export default class SoundPlayer { 
    private static instance: SoundPlayer;
    private clickSound: { 
        click: HTMLAudioElement;
        [key:string]:HTMLAudioElement
    };
    private volume: number; // 音量（0~1）
    private store: any;

    constructor() {
        // 预加载音效
        this.clickSound = {
            click: new Audio('/mp3/01.WAV'),
        }
        this.store = store
        this.volume = this.store.state.persistence.sounds.otherSound
    }

    private play(soundKey:string):void{
        const sound = this.clickSound[soundKey]
        if(!sound){
            console.error(`未找到声音 ${soundKey}`)
            return
        }
        sound.volume = this.store.state.persistence.sounds.otherSound
        sound.currentTime = 0
        try{
            sound.play()
        }catch(e){
            console.warn('音频播放异常:', e);
        }
    }

    // 播放点击音效的快捷方法
    playClick(){
        this.play('click')
    }


    //设置音量 (0-1)
    setVolume(volume: number):void{
        this.volume = Math.max(0, Math.min(1, volume));
        Object.values(this.clickSound).forEach(sound => {
            sound.volume = this.volume;
        });
    }

    // 获取单例实例
    static getInstance(): SoundPlayer {
        if (!SoundPlayer.instance) {
            SoundPlayer.instance = new SoundPlayer();
        }
        return SoundPlayer.instance;
    }
}